import { SearchPage } from './SearchPage';
import { CoveoSearchEngineProvider } from './CoveoSearchEngine';
import './CoveoSearch.scss';
export function CoveoSearchPage({ShowAISummary}: {ShowAISummary?: boolean}) {
  return <SearchPageWrapper analyticsEnabled={true} searchOnLoad={true} showAISummary={ShowAISummary} />;
}
interface SearchPageWrapperProps {
  analyticsEnabled: boolean;
  searchOnLoad: boolean;
  showAISummary?: boolean;
}
export function SearchPageWrapper({ analyticsEnabled, searchOnLoad, showAISummary }: SearchPageWrapperProps) {
  return (
    <CoveoSearchEngineProvider analyticsEnabled={analyticsEnabled}>
      <SearchPage searchOnLoad={searchOnLoad} showAISummary={showAISummary} />
    </CoveoSearchEngineProvider>
  );
}

export default CoveoSearchPage;
